import React from "react";
import { Card, Col } from "antd";
import { ThunderboltFilled } from "@ant-design/icons";
import LineChart from "./LineChart";

const UploadsAnalyticsChart = ({ chartData }) => {
  return (
    <Col span={24} md={24}>
      <Card
        bordered={false}
        className="criclebox"
        style={{ marginBottom: "16px", borderRadius: "16px" }}
        bodyStyle={{ padding: 0 }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", padding: "20px 24px 8px 24px" }}>
          <div>
            <h4 style={{ margin: 0, fontSize: "16px", fontWeight: "800", color: "#111827", letterSpacing: "0.5px" }}>
              OPERATIONAL MOMENTUM
            </h4>
            <span style={{ fontSize: "11px", color: "#9ca3af", fontWeight: "600", letterSpacing: "0.5px" }}>
              PULSE OF WEEKLY USER ENGAGEMENT
            </span>
          </div>
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "36px",
            height: "36px",
            borderRadius: "50%",
            backgroundColor: "#fef2f2",
            color: "#ef4444"
          }}>
            <ThunderboltFilled style={{ fontSize: "16px" }} />
          </div>
        </div>

        <div style={{ padding: "0 24px 20px 24px" }}>
          <LineChart
            chartData={chartData}
            title="Uploads Per Day"
          />
        </div>
      </Card>
    </Col>
  );
};

export default UploadsAnalyticsChart;
